import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdatePlatformMenuItemsMutation } from "../graphql/mutations";
import type {
  UpdatePlatformMenuItemsMutationType,
  UpdatePlatformMenuItemsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdatePlatformMenuItemsMutation = (
  options?: MutationHookOptions<
    UpdatePlatformMenuItemsMutationType,
    UpdatePlatformMenuItemsMutationVariablesType
  >
) => {
  return useMutation<
    UpdatePlatformMenuItemsMutationType,
    UpdatePlatformMenuItemsMutationVariablesType
  >(UpdatePlatformMenuItemsMutation, options);
};
